<div class="row px-3 div-inputs div-inputs-code-v">
  <input class="mb-4 input-number" min="0" max="1" (input)="keypressInput($event, num2)" id="num1"  #num1 />
  <input class="mb-4 input-number" min="0" max="1" (input)="keypressInput($event, num3)" id="num2"  #num2 />
  <input class="mb-4 input-number" min="0" max="1" (input)="keypressInput($event, num4)" id="num3"  #num3 />
  <input class="mb-4 input-number" min="0" max="1" (input)="keypressInput($event, num5)" id="num4"  #num4 />
  <input class="mb-4 input-number" min="0" max="1" (input)="keypressInput($event, num6)" id="num5"  #num5 />
  <input class="mb-4 input-number" min="0" max="1" (input)="keypressInput($event, num7)" id="num6"  #num6 />
  <input class="mb-4 input-number" min="0" max="1" (input)="keypressInput($event, num8)" id="num7"  #num7 />
  <input class="mb-4 input-number" min="0" max="1" (input)="keypressInput($event, num8)" id="num8"  #num8 />
</div>
